// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-different__header{text-align:center;margin:80px 0 32px}.search-different__header__title{font-weight:500;font-size:42px;line-height:1.3;letter-spacing:0px;font-family:Tiempos Fine;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}@media screen and (max-width: 48em){.search-different__header__title{font-size:28px}}.search-different__header__subtitle{max-width:600px;margin:16px auto 24px auto;font-weight:400;font-size:19px;line-height:1.5em}\n", ""]);
// Exports
module.exports = exports;
